/*
  德语(de)
*/
export default {
  // 支付
  common: {
    default: 'Standard',
    delete: 'Löschen',
    cancel: 'Abbrechen',
    submit: 'einreichen',
    inputContent: 'Eingabeinhalt',
    selectContent: 'Inhalt auswählen',
    pleaseEnter: 'Bitte eingeben',
    confirm: 'bestätigen Sie',
    Warning: 'Warnung',
    success: 'Erfolg',
    next: 'nächste'
  },
  payment: {
    payment: 'Zahlung',
    availableBalance: 'Verfügbares Guthaben',
    topUp: 'Aufladen',
    creditCard: 'Kreditkarte',
    settings: 'die Einstellungen',
    transactions: 'Transaktionen',
    paymentMethods: 'Zahlungsmethoden',
    type: 'Typ',
    orderNumber: 'Bestellnummer',
    amount: 'Betragen',
    transactionTime: 'Transaktionszeit',
    allType: 'Alle Arten',
    expenditure: 'Ausgaben',
    income: 'Einkommen',
    balance: 'Gleichgewicht',
    refund: 'Erstattung',
    sample: 'Stichprobe',
    purchase: 'Kaufen',
    orderGoods: 'Waren bestellen',
    cardNo: 'Karten-Nr',
    expireDate: 'Ablaufdatum',
    addCard: 'Karte hinzufügen',
    startDate: 'Startdatum',
    endDate: 'Endtermin',
    export: 'Export',
    enterAmount: 'Geben Sie den Betrag ein',
    dropshipping: 'Dropshipping',
    recharge: 'Aufladen',
    orderDeposit: 'Anzahlung bestellen',
    orderBalance: 'Auftragsbestand',
    systemTopup: 'Systemaufladung',
    giftCard: 'Geschenkkarte'
  },
  // 地址
  address: {
    address: 'Die Anschrift',
    editTheAddress: 'Bearbeiten Sie die Adresse',
    setAsDefault: 'Als Standard festlegen',
    addAddress: 'Adresse hinzufügen',
    fullName: 'Vollständiger Name',
    phoneNumber: 'Telefonnummer',
    streetAddressLine1: 'Straße Adresse 1',
    streetAddressLine2: 'Straße Adresse 2',
    city: 'Stadt',
    state: 'Bundesland',
    provice: 'Provinz',
    region: 'Region',
    country: 'Land',
    zipCode: 'Postleitzahl',
    vat: 'MwSt.',
    setAsDefaultAddress: 'Als Standardadresse festlegen',
    defaultAddress: 'Standardadresse',
    stateProviceRegion: 'Bundesland/Provinz/Region',
    deleteTip: 'Sind Sie sicher, diese Adresse zu löschen?'
  },
  // 店铺
  store: {
    store: 'Geschäft',
    stores: 'Shops',
    allStores: 'Alle Geschäfte',
    storeTips: 'Sobald Ihr Geschäft hinzugefügt wurde, können Sie mit nur wenigen Klicks Zehntausende Trendartikel in Ihrem Geschäft veröffentlichen. KakaClo kümmert sich um alles andere für Sie, nachdem eine Bestellung in Ihrem Geschäft aufgegeben wurde.',
    allowStoreBinding: 'Store-Bindung zulassen',
    connectANewStore: 'Verbinden Sie einen neuen Shop',
    authorized: 'Autorisiert',
    unauthorized: 'Nicht autorisiert',
    reauthorize: 'Erneut autorisieren',
    storeSettings: 'Store-Einstellungen',
    removeStoreTitle: 'Möchten Sie diesen Shop wirklich entfernen??',
    removeStoreTips: 'Wenn Sie nur die Synchronisierung von Store-Daten mit unserer Plattform beenden und Ihre Store-Einstellungen beibehalten möchten, können Sie den Store deaktivieren, anstatt ihn zu entfernen.',
    removeStoreTips1: 'Nachdem der Store entfernt wurde, werden auch die folgenden mit dem Store verknüpften Daten entfernt und können nicht wiederhergestellt werden:',
    listings: 'Listings',
    OrdersOfstore: 'Bestellungen des Ladens.',
    removeTheStore: 'Entfernen Sie den Shop',
    storeUrl: 'Store-URL',
    openStoreMsg: 'Herzlichen Glückwunsch zur Aktivierung, Sie erhalten die Bestellung Ihres gebundenen Shops!',
    closeStoreAlert: 'Möchten Sie den Shop wirklich deaktivieren?',
    closeStoreTips: 'Sie können keine Bestellungen mehr annehmen, nachdem der Shop deaktiviert wurde',
    chooseStoreTip: 'Wählen Sie die Plattform Ihres Shops',
    addStoreTip: 'NUR eintreten',
    addStoreTip2: 'Ihre Standarddomäne',
    shopifyTips: 'Melden Sie sich bei Ihrem Shopify-Adminbereich an, um Ihre Standarddomäne zu finden',
    shopifyTips1: 'z.B. www.Ihre-Default-Domain.myshopify.com',
    shoplazzaTips: 'Melden Sie sich bei Ihrem Shoplazza-Admin an, um Ihre Standarddomäne zu finden.',
    shoplazzaTips1: 'z.B. www.Ihre-Default-Domain.shoplazza.com',
    shoplineTips: 'Melden Sie sich bei Ihrem Shopline-Admin an, um Ihre Standarddomäne zu finden.',
    shoplineTips1: 'z.B. www.Ihre-Default-Domain.shopline.com',
    eg: 'z.B. ',
    addStoreVideoTip: 'So verbinden Sie ein neues Geschäft'
  },
  // 店铺设置
  storeSetting: {
    storeStting: 'Store-Einstellung',
    storeName: 'Name des Ladens',
    whetherToAuthorize: 'Ob zu autorisieren',
    storeLink: 'Store-Link',
    taxRuleTitle: 'Das Produkt steuerpflichtig machen?',
    taxRuleTip: 'Gibt an, ob beim Verkauf der Produktvariante eine Steuer erhoben wird oder nicht.',
    productRules: 'Produktregeln',
    productRuleTip: 'Wählen Sie eine Aktion, wenn sich der Bestand des mit Ihrer Shop-Sku verbundenen Artikels ändert.',
    dontDealWidth: 'Keine Maßnahmen ergreifen',
    productRuleY: 'Store-SKU-Bestand automatisch aktualisieren',
    priceRules: 'Preisregeln',
    storeCurrency: 'Shop-Währung',
    compareAtPrice: 'Zum Preis vergleichen',
    price: 'Preis',
    originalPrice: 'Vorgeschlagener Preis',
    multiplier: 'Multiplikator',
    shipping: 'Versandkosten',
    orderRules: 'Bestellregeln',
    orderRulesTip1: 'Bitte wählen Sie eine Aktion Wenn der Lieferant des Geschäfts die Ware liefert.',
    orderRulesY: 'Laden Sie die Logistiknummer automatisch in den Laden hoch.',
    orderRulesTip2: 'Wenn Ihr Geschäft eine neue Bestellung erhält, ob die Bestellung automatisch aufgegeben wird.',
    orderRulesTip2N: 'Nicht automatisch gekauft',
    orderRulesTip2Y: 'Automatisch kaufen',
    save: 'speichern',
    selectCurrency: 'Währung wählen',
    productCost: 'Produktkosten'
  },
  // 注册身份
  signupUser: {
    questionTile: 'Wie würden Sie sich in der Modebranche beschreiben?',
    answer1: 'Ich bin ein Online-Verkäufer',
    answer2: 'Ich bin ein stationärer Verkäufer',
    answer3: 'Ich bin ein Omni-Channel-Verkäufer',
    answer4: 'Ich bin ein Influencer',
    answer5: 'Ich bin ein Kunde',
    answer6: 'Sonstiges'
  },
  // my information
  myInformation: {
    myInformation: 'Meine Information'
  }
}
